import { render, staticRenderFns } from "./BaseSelectbox.vue?vue&type=template&id=4d1279b5&"
import script from "./BaseSelectbox.vue?vue&type=script&lang=js&"
export * from "./BaseSelectbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports